module.exports = __webpack_public_path__ + "static/media/copy-solid.0cdfdf3b.svg";